module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./SetQrcodeView.js"));
	}, "SetQrcodeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SetQrcodeView!./src/pages/PunchClock/SetQrcode/SetQrcodeView.js
// module id = 1275
// module chunks = 431